import userSettingsSlice, { UserSettingsSlice as _UserSettingsSlice } from './userSettingsSlice'

export type UserSettingsSlice = _UserSettingsSlice
export const userSettingsReducer = userSettingsSlice.reducer
export const userSettingsActions = userSettingsSlice.actions
export default userSettingsSlice